export const SAILPOINT_DATA_OBJECT_TYPES = [
  'Application',
  'CorrelationConfig',
  'PasswordPolicy',
  'EmailTemplate',
  'Workgroup',
  'CustomObject',
  'Custom',
];

export const OIM_DATA_OBJECT_TYPES = [
  'Application',
  'PasswordPolicy',
  'Datasets',
  'UserGroups',
  'EnterpriseRoles',
];

export const REMOVE_OIM_CONFIG_MIGRATION_OBJECTS = [
  'Account',
  'RequestableEntitlements',
  'Identity',
  'UsersAssignedEntitlements',
];
